import { throwRepoErrorFromApiV3Error } from '@webapp/core/utils/repositories/throwRepoErrorFromApiV3Error'
import { type IHttpClient } from '@webapp/infrastructure/interfaces/services/IHttpClient'
import { type IGlobalSearchRepository } from '../../business-logic/interfaces/IGlobalSearchRepository'
import { GlobalSearchResult } from '../../value-objects/GlobalSearchResult'
import { GlobalSearchResultItem } from '../../value-objects/GlobalSearchResultItem'
import { mapGlobalSearchResultsApiModel } from '../mappers/mapGlobalSearchResultsApiModel'
import { type GlobalSearchPayload } from '../types/GlobalSearchPayload'
import { type GlobalSearchResponse } from '../types/GlobalSearchResponse'

interface Dependency {
  httpClient: IHttpClient
}

export class GlobalSearchRepository implements IGlobalSearchRepository {
  constructor(private readonly deps: Dependency) {}

  async search(payload: GlobalSearchPayload): Promise<GlobalSearchResult> {
    try {
      const response = await this.deps.httpClient.post<GlobalSearchResponse>(
        '/api/v3/global-command/search/',
        payload
      )

      const { data: items, metadata } = response.data
      const globalSearchResults = mapGlobalSearchResultsApiModel(
        items,
        metadata
      )

      return new GlobalSearchResult({
        items: globalSearchResults.items.map(
          (item) => new GlobalSearchResultItem(item)
        ),
        counts: globalSearchResults.counts,
        total: globalSearchResults.total,
        isTruncated: globalSearchResults.isTruncated,
        isUnsupportedQuery: globalSearchResults.isUnsupportedQuery,
        noResultsMessage: globalSearchResults.noResultsMessage,
        unsupportedQueryMessage: globalSearchResults.unsupportedQueryMessage,
      })
    } catch (error) {
      throw throwRepoErrorFromApiV3Error(error)
    }
  }
}
